<!-- 数据统计首页 -->
<template>
  <div class="data-statistic-container">
    <div class="search-wrap" style="position: relative">
      <div class="btn-group">
        <div
          class="btn"
          :class="btnActive == -1 ? 'btn-active' : ''"
          @click="dateChange(-1)"
        >
          昨日
        </div>
        <div
          class="btn"
          :class="btnActive == 7 ? 'btn-active' : ''"
          @click="dateChange(7)"
        >
          近7日
        </div>
        <div
          class="btn"
          :class="btnActive == 30 ? 'btn-active' : ''"
          @click="dateChange(30)"
        >
          近30日
        </div>
      </div>
      <el-date-picker
        v-model="searchSelectTime"
        size="mini"
        :editable="false"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="-"
        start-placeholder="统计时间"
        end-placeholder="统计时间"
        :picker-options="pickerOptions"
        @change="selectTime"
        clearable
        style="width: 240px; margin-right: 12px"
      >
      </el-date-picker>
      <span slot="reference" class="tip" @click="openTipDialog(1)"
        >统计说明 <i class="el-icon-question"></i
      ></span>

      <div class="popover">
        <el-popover placement="bottom" width="190" trigger="click">
          <div style="text-align: right; font-size: 12px">
            可选数量{{ SelectSetLength }}/10
          </div>
          <div class="list">
            <div
              class="item"
              v-for="(item, i) in setting"
              :class="{ active: item.isShow == 1 }"
              @click="selectItem(item)"
            >
              {{ item.fieldName }}
            </div>
          </div>
          <el-button slot="reference" size="small">字段设置</el-button>
        </el-popover>
      </div>
    </div>
    <!--  -->
    <div class="card-wrap">
      <div
        class="card-item"
        v-for="(item, index) in selectItemList"
        :key="index"
        @click="clickItem(item)"
        :class="{ isClick: topDataList[item].path && topDataList[item].isGo }"
      >
        <img :src="topDataList[item].icon" class="item-icon" alt="" />
        <div class="item-data">
          <div class="data-title">{{ topDataList[item].text }}</div>
          <div class="data-num">
            <div
              class="card-content"
              :style="{ color: topDataList[item] && topDataList[item].color }"
            >
              {{ topDataList[item].value }}
            </div>
            <i
              class="el-icon-arrow-right card-icon"
              v-if="topDataList[item].path && topDataList[item].isGo"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 折线图 新增客户波动start-->
    <div class="zhe-xian-wrap">
      <div class="zhe-xian-title">
        <div class="title-name-wrap">
          <!-- :class="showCustomBtn ? '' : 'no-click'" -->
          <span
            class="title-name "
            :class="type == 1 ? 'title-more' : ''"
            @click="getCusStatistic"
            >新增客户波动</span
          >
          <!-- :class="showCustomBtn ? '' : 'no-click'" -->
          <span
            class="title-name"
            :class="type == 2 ? 'title-more' : ''"
            @click="getnewGroupChatData"
            >新增群聊趋势</span
          >
        </div>
        <!-- <div
          class="title-name-wrap"
          @click="showCustomBtn ? addCustomerShow() : ''"
        >
          <span class="title-more" v-show="showCustomBtn"
            >更多<i class="el-icon-arrow-right"></i
          ></span>
        </div> -->
      </div>
      <div id="zheXiangTu" style="width: 100%; height: 277px"></div>
      <!-- <div id="quShi" style="width: 100%;height: 277px;"></div> -->
      <div class="flag-color" v-if="type == 1">
        <div class="line-type">
          <div class="type-item">
            <div class="dot xin-zeng-dot"></div>
            <div class="type-name">新增客户</div>
          </div>
          <div class="type-item">
            <div class="dot xin-bang-dot"></div>
            <div class="type-name">新绑档案</div>
          </div>
        </div>
      </div>
      <div class="flag-color" v-else>
        <div class="line-type">
          <div class="type-item">
            <div class="dot xin-zeng-dot"></div>
            <div class="type-name">新增群聊</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 折线图 end-->
    <!-- 聊天概况、员工排名 -->
    <div class="bottom-wrap">
      <!-- 聊天概况 -->
      <div class="staff-rank-wrap">
        <div class="head-wrap">
          <div @click="customerStatisticsShow">
            <span class="title-name">员工好友概况</span>
            <span class="title-more"
              >更多<i class="el-icon-arrow-right"></i
            ></span>
          </div>
          <span class="tip">(本表为历史数据总和，不受页面左上角时间控制)</span>
        </div>
        <div class="table-wrap">
          <div class="table-data">
            <el-table
              size="medium"
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
              ref="singleTable"
              :highlight-current-row="true"
              :data="staffRankData"
              @sort-change="customerSortChange"
              :default-sort="{ prop: 'bindDangAnCount', order: 'descending' }"
              height="353px"
              style="width: 100%; height: 100%; font-size: 13px"
            >
              <el-table-column label="序号" width="65" align="center">
                <template slot-scope="scope">
                  <!-- <span>{{scope.$index + 1}}</span> -->
                  {{
                    pageparm.pageSize * (pageparm.currentPage - 1) +
                      (scope.$index + 1)
                  }}
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="userName"
                label="员工姓名"
                min-width="88"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="bindDangAnCount"
                sortable="custom"
                label="绑定档案数"
                min-width="88"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="bindCusCount"
                sortable="custom"
                label="绑定客户数"
                min-width="88"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="friendNumb"
                sortable="custom"
                label="好友总数"
                min-width="88"
                align="center"
              ></el-table-column>
            </el-table>
          </div>
          <div class="staff-pagination">
            <el-pagination
              @current-change="callBack"
              background
              :current-page.sync="pageparm.currentPage"
              :page-size="pageparm.pageSize"
              layout="prev, pager, next, jumper"
              :total="pageparm.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <!-- 员工排名 -->
      <div class="staff-rank-wrap">
        <div class="head-wrap">
          <div @click="customerChatShow">
            <span class="title-name">员工群聊概况</span>
            <span class="title-more"
              >更多<i class="el-icon-arrow-right"></i
            ></span>
          </div>
          <span class="tip">(本表为历史数据总和，不受页面左上角时间控制)</span>
        </div>
        <div class="table-wrap">
          <div class="table-data">
            <el-table
              size="medium"
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
              ref="singleTable"
              :highlight-current-row="true"
              :data="groupChat"
              @sort-change="customerSortChange"
              :default-sort="{ prop: 'bindDangAnCount', order: 'descending' }"
              height="353px"
              style="width: 100%; height: 100%; font-size: 13px"
            >
              <el-table-column label="序号" width="65" align="center">
                <template slot-scope="scope">
                  <!-- <span>{{scope.$index + 1}}</span> -->
                  {{
                    pageParmChat.pageSize * (pageParmChat.currentPage - 1) +
                      (scope.$index + 1)
                  }}
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="userName"
                label="员工姓名"
                min-width="88"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="memberHasMsg"
                label="活跃群聊数"
                min-width="88"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="msgTotal"
                label="群聊消息数"
                min-width="88"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="memberTotal"
                label="群聊人数"
                min-width="88"
                align="center"
              ></el-table-column>
            </el-table>
          </div>
          <div class="staff-pagination">
            <el-pagination
              @current-change="callBackChat"
              background
              :current-page.sync="pageParmChat.currentPage"
              :page-size="pageParmChat.pageSize"
              layout="prev, pager, next, jumper"
              :total="pageParmChat.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 聊天概况、员工排名 -->
    <!-- 统计说明弹框 -->
    <StatisticDialog ref="tipDialog" />
    <!-- <addCustomer ref="addCustomer" /> -->
    <customerStatistics ref="customerStatistics" />
    <customerChat ref="customerChat" />
    <!-- <customerContact ref="customerContact" /> -->
  </div>
</template>

<script>
import StatisticDialog from "@/views/dataStatistics/components/statisticDialog.vue";
import addCustomer from "@/views/dataStatistics/components/addCustomer.vue";
import customerStatistics from "@/views/dataStatistics/components/customerStatistics.vue";
// import customerChat from "@/views/dataStatistics/components/customerChat.vue";
import customerContact from "@/views/dataStatistics/components/customerContact.vue";
import customerChat from "@/views/groupChat/components/customerStatistics.vue";
import {
  getEmpRank,
  getCusStatistic,
  getEmpChatCusStatistic,
  getCusHistoryData,
  getFieldData,
  getgroupChatData,
  getnewGroupChatData,
  updateField,
  getGroupChatDatas,
} from "@/api/dataStatistics/dataStatistics.js";
export default {
  components: {
    StatisticDialog,
    addCustomer,
    customerStatistics,
    customerContact,
    customerChat,
  },
  data() {
    return {
      showCustomBtn: false,
      currentSelectMember: [],
      searchSelectTime: "",
      btnActive: 7,
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      pageParmChat: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      avgReplyTimeCount: 0, //平均首次回复时长
      // 员工排名请求参数
      staffRankParams: {
        mark: 7, //标识 -1：昨日  7：近七日  30：近30日  【int，非必传,mark与统计时间范围要选择其中一个，如果两者都选按mark为准】
        startTime: "", //开始时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
        endTime: "", //结束时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
        bindDangAnSort: "bindDangAnSortDesc", //绑定档案数排序【非必传】
        bindCusSort: "", //绑定客户数排序【非必传】
        friendNumbSort: "", //好友总数【非必传】
        pageNum: 1, //页码【必传】
        pageSize: 10, //页数【必传】
      },
      // 聊天概况请求参数
      chatParams: {
        mark: 7, //标识 -1：昨日  7：近七日  30：近30日  【int，非必传,mark与统计时间范围要选择其中一个，如果两者都选按mark为准】
        judge: 1, //1：切换到聊天总数   2：切换到发送消息数 【int，必传】
        startTime: "", //开始时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
        endTime: "", //结束时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
      },
      // 新增客户波动请求参数
      newCusParams: {
        mark: 7, //标识 -1：昨日  7：近七日  30：近30日  【int，非必传,mark与统计时间范围要选择其中一个，如果两者都选按mark为准】
        startTime: "", //开始时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
        endTime: "", //结束时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
      },
      // 顶部数据
      topDataList: [
        {
          icon: require("@/assets/img/customNum1.png"),
          text: "客户总数",
          value: 0,
          path: "/customer/Eamc",
          isGo: true,
        },
        {
          icon: require("@/assets/img/customNum2.png"),
          text: "新增客户数",
          value: 0,
          path: "/customer/Eamc",
          isGo: true,
        },
        {
          icon: require("@/assets/img/customNum3.png"),
          text: "绑定客户数",
          value: 0,
          path: "/customer/Eamc",
          isGo: true,
        },
        {
          icon: require("@/assets/img/customNum4.png"),
          text: "绑定档案数",
          value: 0,
          path: "/customer/Eamc",
          isGo: true,
        },
        {
          icon: require("@/assets/img/customNum5.png"),
          text: "新绑档案数",
          value: 0,
          path: "/customer/Eamc",
          isGo: true,
        },
        {
          icon: require("@/assets/img/customNum6.png"),
          text: "发起申请数",
          value: 0,
          isGo: false,
        },
        {
          icon: require("@/assets/img/customNum7.png"),
          text: "聊天总数",
          value: 0,
          path: "/chat/CusChatSupervise",
          isGo: true,
        },
        {
          icon: require("@/assets/img/customNum8.png"),
          text: "发送消息数",
          value: 0,
          path: "/chat/CusChatSupervise",
          isGo: true,
        },
        {
          icon: require("@/assets/img/customNum9.png"),
          text: "删除/拉黑数",
          value: 0,
          color: "#f00",
          path: "/employeeChatStatistics/index",
          isGo: true,
        },
        {
          icon: require("@/assets/img/customNum10.png"),
          text: "删除/拉黑总数",
          value: 0,
          color: "#f00",
          path: "/employeeChatStatistics/index",
          isGo: true,
        },

        {
          icon: require("@/assets/img/customNum3.png"),
          text: "总群聊数",
          value: 0,
          path: "/group/list",
          isGo: true,
        },
        {
          icon: require("@/assets/img/customNum4.png"),
          text: "新增群聊数",
          value: 0,
          path: "/group/list",
          isGo: true,
        },
        {
          icon: require("@/assets/img/customNum5.png"),
          text: "活跃成员数",
          value: 0,
          path: "/group/list",
          isGo: true,
        },
        {
          icon: require("@/assets/img/customNum6.png"),
          text: "群聊消息数",
          value: 0,
          path: "/group/list",
          isGo: true,
        },
        {
          icon: require("@/assets/img/customNum7.png"),
          text: "群日均消息数",
          value: 0,
          path: "/group/list",
          isGo: true,
        },
        {
          icon: require("@/assets/img/customNum8.png"),
          text: "群聊总人数",
          value: 0,
        },
        {
          icon: require("@/assets/img/customNum9.png"),
          text: "进群人数",
          value: 0,
        },
        {
          icon: require("@/assets/img/customNum10.png"),
          text: "退群人数",
          value: 0,
        },
      ],
      // 员工排行表格数据
      staffRankData: [],
      pickerOptions: {
        disabledDate: (time) => {
          let curDate = new Date().getTime();
          const day = 180 * 24 * 3600 * 1000;
          return (
            time.getTime() > Date.now() - 8.64e7 ||
            time.getTime() < curDate - day
          );
        },
      },
      // 字段设置
      setting: [],
      // 员工群聊概况
      groupChat: [],
      // 员工群聊参数
      groupChatParams: {
        mark: 7, //标识 -1：昨日  7：近七日  30：近30日  【int，非必传,mark与统计时间范围要选择其中一个，如果两者都选按mark为准】
        startTime: "", //开始时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
        endTime: "", //结束时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
        // userIdList: ["woHiy3CAAA355lnYOLIjs8CPaRYsgQjg"],
        // bindDangAnSort: "bindDangAnSortDesc",    //绑定档案数排序【非必传】
        // bindCusSort: "",    //绑定客户数排序【非必传】
        // friendNumbSort: "",    //好友总数【非必传】
        pageNum: 1, //页码【必传】
        pageSize: 10, //页数【必传】
      },
      // 新增群聊趋势请求参数
      newGroupChatParams: {
        mark: 7, //标识 -1：昨日  7：近七日  30：近30日  【int，非必传,mark与统计时间范围要选择其中一个，如果两者都选按mark为准】
        startTime: "", //开始时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
        endTime: "", //结束时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
        trendValue: "newChatCnt",
      },
      type: 1, //判断是群聊还是客户波动
      SelectSetLength: 0, //判断已经选择的个数
      selectItemList: [],
    };
  },
  mounted() {
    this.changetype();
    this.getStaffRank();
    this.getCusHistoryData();
    this.getCusStatistic();
    this.getEmpChatCusStatistic();
    this.getField();
    this.getgroupChat();
    // this.getGroupChatDatas()
    // this.getnewGroupChatData();
  },
  methods: {
    /**点击跳转 */
    clickItem(item) {
      console.log(
        "点击---首页看板",
        item,
        this.topDataList[item],
        this.staffRankParams.startTime,
        this.staffRankParams.endTime,
        this.staffRankParams.mark
      );
      let startTimeM = this.staffRankParams.startTime;
      let endTimeM = this.staffRankParams.endTime;
      if (!startTimeM && this.staffRankParams.mark >= -1) {
        // 获取当前日期
        let today = new Date();
        switch (this.staffRankParams.mark) {
          case -1:
            // 昨天
            let yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);
            // 格式化日期为YYYY-MM-DD
            startTimeM = yesterday.toISOString().split("T")[0];
            endTimeM = yesterday.toISOString().split("T")[0];

            break;
          case 7:
            // 近7日
            const sevenDaysAgo = new Date(
              today.getTime() - 7 * 24 * 60 * 60 * 1000
            );
            const year = sevenDaysAgo.getFullYear();
            const month = (sevenDaysAgo.getMonth() + 1)
              .toString()
              .padStart(2, "0");
            const date = sevenDaysAgo
              .getDate()
              .toString()
              .padStart(2, "0");
            startTimeM = `${year}-${month}-${date}`;

            let yesterday2 = new Date(today);
            yesterday2.setDate(today.getDate() - 1);
            endTimeM = yesterday2.toISOString().split("T")[0];

            break;
          case 30:
            // 近30日
            const sevenDaysAgo2 = new Date(
              today.getTime() - 30 * 24 * 60 * 60 * 1000
            );
            const year2 = sevenDaysAgo2.getFullYear();
            const month2 = (sevenDaysAgo2.getMonth() + 1)
              .toString()
              .padStart(2, "0");
            const date2 = sevenDaysAgo2
              .getDate()
              .toString()
              .padStart(2, "0");
            startTimeM = `${year2}-${month2}-${date2}`;

            let yesterday3 = new Date(today);
            yesterday3.setDate(today.getDate() - 1);
            endTimeM = yesterday3.toISOString().split("T")[0];

            break;

          default:
            break;
        }
      }

      console.log("点击---666", startTimeM, endTimeM);
      if (this.topDataList[item].path) {
        switch (this.topDataList[item].path) {
          case "/customer/Eamc":
            this.$router.push({
              path: this.topDataList[item].path,
              query: startTimeM ? { dateArr: [startTimeM, endTimeM] } : "",
            });
            break;
          case "/group/list":
            this.$router.push({
              path: this.topDataList[item].path,
              query: startTimeM
                ? { startTime: startTimeM, endTime: endTimeM }
                : "",
            });
            break;
          case "/employeeChatStatistics/index":
            this.$router.push({
              path: this.topDataList[item].path,
              query: this.staffRankParams.mark
                ? {mark:this.staffRankParams.mark}
                : {
                    dateArr: [
                      this.staffRankParams.startTime,
                      this.staffRankParams.endTime,
                    ],
                  },
            });
            break;
          default:
            this.$router.push({ path: this.topDataList[item].path });
            break;
        }
      }
    },
    // 获取看板数据
    getGroupChatDatas() {
      getGroupChatDatas(
        this.newGroupChatParams,
        localStorage.getItem("Authorization")
      ).then((res) => {
        Object.values(res.data).forEach((item, index) => {
          this.topDataList[index + 10].value = item;
        });
        this.selectItemList = [];
        this.setting.forEach((item, index) => {
          if (item.isShow == 1) {
            this.selectItemList.push(index);
          }
        });
        // console.log(this.selectItemList)
      });
    },
    // 字段设置
    selectItem(item) {
      if (this.SelectSetLength > 10 && item.isShow == 0) {
        this.$message.warning("最多只能选择10个哦！");
        return;
      }
      if (item.isShow == 1) {
        item.isShow = 0;
        updateField(item, localStorage.getItem("Authorization")).then((res) => {
          this.getField();
        });
      } else {
        item.isShow = 1;
        updateField(item, localStorage.getItem("Authorization")).then((res) => {
          this.getField();
        });
      }
    },
    // 获取字段设置数据
    getField() {
      getFieldData(localStorage.getItem("Authorization"), false).then((res) => {
        this.setting = res.data;
        this.SelectSetLength = res.data.filter(
          (item) => item.isShow == 1
        ).length;
        this.getGroupChatDatas();
      });
    },
    // 获取群聊数据
    getgroupChat() {
      getgroupChatData(
        this.groupChatParams,
        localStorage.getItem("Authorization"),
        false
      ).then((res) => {
        this.groupChat = res.data.result;
        this.pageParmChat.total = res.data.total;
      });
    },
    // 获取新增群聊趋势
    getnewGroupChatData() {
      getnewGroupChatData(
        this.newGroupChatParams,
        localStorage.getItem("Authorization")
      ).then((res) => {
        this.changetype(res.data.dateTimeX, [], res.data.valueY, 2);
        // console.log(res);
      });
    },
    chatClick() {
      this.$nextTick(() => {
        this.$refs.customerContact.show();
      });
    },
    // 客户添加弹框
    addCustomerShow() {
      this.$nextTick(() => {
        this.$refs.addCustomer.show();
      });
    },
    // 切换聊天总数图/发送消息数图
    // changeChat(val) {
    //   this.chatParams.judge = val;
    //   this.getEmpChatCusStatistic();
    // },
    // 员工统计弹框
    customerStatisticsShow() {
      this.$nextTick(() => {
        this.$refs.customerStatistics.show();
      });
    },
    // 员工群聊概况弹出
    customerChatShow() {
      this.$nextTick(() => {
        this.$refs.customerChat.show();
      });
    },
    // 排序规则改变
    customerSortChange(val) {
      this.staffRankParams.bindDangAnSort = "";
      this.staffRankParams.bindCusSort = "";
      this.staffRankParams.friendNumbSort = "";
      this.staffRankParams.pageNum = 1;
      this.pageparm.currentPage = 1;
      switch (val.prop) {
        case "bindDangAnCount":
          // 绑定档案数
          this.staffRankParams.bindDangAnSort =
            val.order == "descending"
              ? "bindDangAnSortDesc"
              : val.order == "ascending"
              ? "bindDangAnSortAsc"
              : "";
          break;
        case "bindCusCount":
          // 绑定客户数
          this.staffRankParams.bindCusSort =
            val.order == "descending"
              ? "bindCusSortDesc"
              : val.order == "ascending"
              ? "bindCusSortAsc"
              : "";
          break;
        case "friendNumb":
          // 好友总数
          this.staffRankParams.friendNumbSort =
            val.order == "descending"
              ? "friendNumbSortDesc"
              : val.order == "ascending"
              ? "friendNumbSortAsc"
              : "";
          break;
      }
      this.getStaffRank();
    },
    callBack(parm) {
      this.staffRankParams.pageNum = parm;
      this.getStaffRank();
    },
    callBackChat(parm) {
      this.groupChatParams.pageNum = parm;
      this.getgroupChat();
      // this.getStaffRank()
    },
    // 选择时间处理
    selectTime(dataTime) {
      if (dataTime != null) {
        this.staffRankParams.startTime = dataTime[0];
        this.staffRankParams.endTime = dataTime[1];
        this.chatParams.startTime = dataTime[0];
        this.chatParams.endTime = dataTime[1];
        this.newCusParams.startTime = dataTime[0];
        this.newCusParams.endTime = dataTime[1];
        this.newGroupChatParams.startTime = dataTime[0];
        this.newGroupChatParams.endTime = dataTime[1];
        this.newGroupChatParams.mark = "";
        this.staffRankParams.mark = "";
        this.chatParams.mark = "";
        this.newCusParams.mark = "";
        this.btnActive = "";
      } else {
        this.staffRankParams.startTime = "";
        this.staffRankParams.endTime = "";
        this.chatParams.startTime = "";
        this.chatParams.endTime = "";
        this.newCusParams.startTime = "";
        this.newCusParams.endTime = "";
        this.staffRankParams.mark = 7;
        this.chatParams.mark = 7;
        this.newCusParams.mark = 7;
        this.btnActive = 7;
        this.newGroupChatParams.startTime = "";
        this.newGroupChatParams.endTime = "";
        this.newGroupChatParams.mark = 7;
      }
      this.pageparm.currentPage = 1;
      this.staffRankParams.pageNum = 1;
      if (this.type == 1) {
        this.getCusStatistic();
      } else {
        this.getnewGroupChatData();
      }

      // this.getStaffRank()
      this.getEmpChatCusStatistic();
      this.getGroupChatDatas();
    },
    // 打开统计说明弹框
    openTipDialog(val) {
      this.$nextTick(() => {
        this.$refs.tipDialog.show(val);
      });
    },
    // 平均首次回复时长提示
    openTip() {},
    // 选择昨日/近7天/近一个月 val=1时为昨日。val=2时为近7天。val=3时为近一个月
    dateChange(val) {
      this.btnActive = val;
      this.pageparm.currentPage = 1;
      this.staffRankParams.pageNum = 1;
      this.staffRankParams.mark = val;
      this.chatParams.mark = val;
      this.newCusParams.mark = val;
      this.searchSelectTime = "";
      this.staffRankParams.startTime = "";
      this.staffRankParams.endTime = "";
      this.chatParams.startTime = "";
      this.chatParams.endTime = "";
      this.newCusParams.startTime = "";
      this.newCusParams.endTime = "";
      this.newGroupChatParams.startTime = "";
      this.newGroupChatParams.endTime = "";
      this.newGroupChatParams.mark = val;
      if (this.type == 1) {
        this.getCusStatistic();
      } else {
        this.getnewGroupChatData();
      }
      // this.getStaffRank()
      this.getEmpChatCusStatistic();
      this.getGroupChatDatas();
    },
    // 折线图 xAxisData:日期横坐标数组,cusBindDateValueY:新绑档案波动纵坐标数组,cusAddDateValueY:新增客户波动纵坐标数组
    changetype(xAxisData, cusBindDateValueY, cusAddDateValueY, type = 1) {
      //1客户波动  2 群聊
      // 获取组件实例
      // return;
      let machart = this.$echarts.getInstanceByDom(
        document.getElementById("zheXiangTu")
      ); //有的话就获取已有echarts实例的DOM节点。
      if (machart) {
        machart.dispose();
        machart = null;
      }
      if (machart == null) {
        // 如果不存在，就进行初始化。
        machart = this.$echarts.init(document.getElementById("zheXiangTu"));
      }
      this.type = type;
      var option = {};
      // 指定图表的配置项和数据
      if (type == 1) {
        option = {
          tooltip: {
            //设置tip提示
            trigger: "axis",
          },
          grid: {
            top: 20,
            right: 32,
            bottom: 24,
            left: 40,
          },
          color: ["#2684FF", "#00A870"], //设置区分（每条线是什么颜色，和 legend 一一对应）
          xAxis: {
            //设置x轴
            type: "category",
            boundaryGap: false, //坐标轴两边不留白
            data: xAxisData,
            axisLine: {
              //坐标轴轴线相关设置。
              show: false,
              lineStyle: {
                color: "#CCCCCC",
              },
            },
            axisLabel: {
              textStyle: {
                color: "rgba(0, 0, 0, 0.9)", //坐标的字体颜色
              },
              margin: 15,
            },
          },
          yAxis: {
            axisLine: {
              lineStyle: {
                color: "#FA6F53",
              },
            },
            // min: (value) => {
            //   return value.min
            // },
            // max: (value) => {
            //   return value.max
            // },
            splitLine: {
              //网格线
              lineStyle: {
                type: "dashed", //设置网格线类型 dotted：虚线   solid:实线
              },
              show: true, //隐藏或显示
            },
            axisLabel: {
              textStyle: {
                color: "rgba(0, 0, 0, 0.9)", //坐标的字体颜色
              },
            },
            type: "value",
          },
          series: [
            {
              name: "新增客户",
              data: cusAddDateValueY,
              smooth: true,
              type: "line", // 类型为折线图
              lineStyle: {
                // 线条样式 => 必须使用normal属性
                color: "#2684FF",
                width: 2,
              },
              symbolSize: 5, //拐点大小
              itemStyle: {
                color: "#2684FF", //拐点颜色
                borderColor: "2684FF", //拐点边框颜色
                borderWidth: 1, //拐点边框大小
                emphasis: {
                  color: "#2684FF", //hover拐点颜色定义
                  borderWidth: 5, //拐点边框大小
                },
              },
              animation: false,
            },
            {
              name: "新绑档案",
              data: cusBindDateValueY,
              smooth: true,
              type: "line", // 类型为折线图
              symbolSize: 5, //拐点大小
              itemStyle: {
                color: "#00A870", //拐点颜色
                borderColor: "#00A870", //拐点边框颜色
                borderWidth: 1, //拐点边框大小
                emphasis: {
                  color: "#00A870", //hover拐点颜色定义
                  borderWidth: 5, //拐点边框大小
                },
              },
              lineStyle: {
                // 线条样式 => 必须使用normal属性
                color: "#00A870",
              },
              animation: false,
            },
          ],
        };
      } else {
        option = {
          tooltip: {
            //设置tip提示
            trigger: "axis",
          },
          grid: {
            top: 20,
            right: 32,
            bottom: 24,
            left: 40,
          },
          color: ["#2684FF"], //设置区分（每条线是什么颜色，和 legend 一一对应）
          xAxis: {
            //设置x轴
            type: "category",
            boundaryGap: false, //坐标轴两边不留白
            data: xAxisData,
            axisLine: {
              //坐标轴轴线相关设置。
              show: false,
              lineStyle: {
                color: "#CCCCCC",
              },
            },
            axisLabel: {
              textStyle: {
                color: "rgba(0, 0, 0, 0.9)", //坐标的字体颜色
              },
              margin: 15,
            },
          },
          yAxis: {
            axisLine: {
              lineStyle: {
                color: "#FA6F53",
              },
            },
            // min: (value) => {
            //   return value.min
            // },
            // max: (value) => {
            //   return value.max
            // },
            splitLine: {
              //网格线
              lineStyle: {
                type: "dashed", //设置网格线类型 dotted：虚线   solid:实线
              },
              show: true, //隐藏或显示
            },
            axisLabel: {
              textStyle: {
                color: "rgba(0, 0, 0, 0.9)", //坐标的字体颜色
              },
            },
            type: "value",
          },
          series: [
            {
              name: "新增群聊",
              data: cusAddDateValueY,
              smooth: true,
              type: "line", // 类型为折线图
              lineStyle: {
                // 线条样式 => 必须使用normal属性
                color: "#2684FF",
                width: 2,
              },
              symbolSize: 5, //拐点大小
              itemStyle: {
                color: "#2684FF", //拐点颜色
                borderColor: "2684FF", //拐点边框颜色
                borderWidth: 1, //拐点边框大小
                emphasis: {
                  color: "#2684FF", //hover拐点颜色定义
                  borderWidth: 5, //拐点边框大小
                },
              },
              animation: false,
            },
          ],
        };
      }

      // 使用刚指定的配置项和数据显示图表。
      machart.setOption(option);
      // 根据页面大小自动响应图表大小
      window.addEventListener("resize", function() {
        machart.resize();
      });
    },
    // 面积图
    // xAxisData: x轴，seriesName：图名称,seriesData：y轴数据
    areaType(xAxisData, seriesName, seriesData) {
      let machart = this.$echarts.getInstanceByDom(
        document.getElementById("chat-survey")
      ); //有的话就获取已有echarts实例的DOM节点。
      console.log("没有进来吗？", machart);
      if (machart == null) {
        // 如果不存在，就进行初始化。
        machart = this.$echarts.init(document.getElementById("chat-survey"));
      }
      var option = {
        tooltip: {
          //设置tip提示
          trigger: "axis",
        },
        grid: {
          top: 20,
          right: 32,
          bottom: 24,
          left: 40,
        },
        color: ["#2684FF"], //设置区分（每条线是什么颜色，和 legend 一一对应）
        xAxis: {
          //设置x轴
          type: "category",
          boundaryGap: false, //坐标轴两边不留白
          data: xAxisData,
          axisLine: {
            //坐标轴轴线相关设置。
            show: false,
            lineStyle: {
              color: "#CCCCCC",
            },
          },
          axisLabel: {
            textStyle: {
              color: "rgba(0, 0, 0, 0.9)", //坐标的字体颜色
            },
            margin: 15,
          },
        },
        yAxis: {
          axisLine: {
            lineStyle: {
              color: "#FA6F53",
            },
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: "dashed", //设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, //隐藏或显示
          },
          axisLabel: {
            textStyle: {
              color: "rgba(0, 0, 0, 0.9)", //坐标的字体颜色
            },
          },
          type: "value",
        },
        series: [
          {
            name: seriesName,
            data: seriesData,
            smooth: true,
            type: "line", // 类型为折线图
            lineStyle: {
              // 线条样式 => 必须使用normal属性
              color: "#2684FF",
            },
            areaStyle: {
              color: "rgba(38, 132, 255, 0.2)", //折线下面区块的颜色
            },
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      machart.setOption(option);
      // 根据页面大小自动响应图表大小
      window.addEventListener("resize", function() {
        machart.resize();
      });
    },
    // 获取员工排行表格
    getStaffRank() {
      getEmpRank(this.staffRankParams, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            this.staffRankData = res.data.empRank;
            this.pageparm.total = res.data.total;
          } else {
            this.$message.error("获取员工排行数据失败，请重试！");
          }
        })
        .catch((err) => {
          this.$message.error("获取员工排行数据失败，请重试！");
        });
    },
    // 首页--获取发起申请数，新增客户数，新绑档案数
    getCusStatistic() {
      getCusStatistic(this.newCusParams, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            // 发起申请数
            this.topDataList[5].value =
              res.data.cusSituationCount.applyCusCount;
            // 新增客户数
            this.topDataList[1].value = res.data.cusSituationCount.addCusCount;
            // 新绑定档案数
            this.topDataList[4].value =
              res.data.cusSituationCount.addBindCusCount;
            // 删除、拉黑数量
            this.topDataList[8].value =
              res.data.cusSituationCount.delBlockCusCount;
            // 折线
            // 日期横坐标数组
            let xAxisData = res.data.dateTimeX;
            // 新绑档案波动纵坐标数组
            let cusBindDateValueY = res.data.cusBindDateValueY;
            // 新增客户波动纵坐标数组
            let cusAddDateValueY = res.data.cusAddDateValueY;
            // 是否显示查看更多客户添加按钮
            this.showCustomBtn = res.data.flag;
            this.changetype(xAxisData, cusBindDateValueY, cusAddDateValueY, 1);
          } else {
            this.$message.error("获取新增客户波动数据失败，请重试！");
          }
        })
        .catch((err) => {
          this.$message.error("获取新增客户波动数据失败，请重试！");
        });
    },
    // 首页--获取聊天总数，发送消息数量，平局首次回复时
    getEmpChatCusStatistic() {
      getEmpChatCusStatistic(
        this.chatParams,
        localStorage.getItem("Authorization")
      )
        .then((res) => {
          if (res.error.code == 200) {
            // 聊天总数
            this.topDataList[6].value = res.data.cusChatCount.chatCntCount;
            // 发送消息数
            this.topDataList[7].value = res.data.cusChatCount.messageCntCount;
            // // 平均首次回复时长
            this.avgReplyTimeCount = res.data.cusChatCount.avgReplyTimeCount;
            let dateTimeX = res.data.dateTimeX;
            let name = "";
            let dateY = [];
            if (res.data.chatCntDateValueY) {
              // 聊天总数图
              name = "聊天总数";
              dateY = res.data.chatCntDateValueY;
            } else {
              // 发送消息图
              name = "发消息数";
              dateY = res.data.messageCntDateValueY;
            }
            // this.$nextTick(() => {
            //   this.areaType(dateTimeX, name, dateY);
            // });
          } else {
            this.$message.error("获取聊天概况数据失败，请重试！");
          }
        })
        .catch((err) => {
          this.$message.error("获取聊天概况数据失败，请重试！");
        });
    },
    // 首页--获取累计绑定客户数，绑定答案数，客户总数
    getCusHistoryData() {
      getCusHistoryData(localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            // 绑定客户数
            this.topDataList[2].value = res.data.bindCusHistoryNum;
            // 绑定档案数
            this.topDataList[3].value = res.data.bindDangAnHistoryNum;
            // 客户总数
            this.topDataList[0].value = res.data.cusHistoryNum;
            // 删除、拉黑总数
            this.topDataList[9].value = res.data.delBlockHistoryNum;
          } else {
            this.$message.error(
              "获取累计绑定客户数，绑定答案数，客户总数失败，请重试！"
            );
          }
        })
        .catch((err) => {
          this.$message.error(
            "获取累计绑定客户数，绑定答案数，客户总数失败，请重试！"
          );
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.data-statistic-container {
  height: 100%;
  min-width: 1200px;
  // background-color: #F4F7FC;
}

// /deep/.el-pagination {
//   .btn-prev,.btn-next {
//     background-color: white;
//     border: 1px solid #E6E9EB;
//   }
//   .el-pager  {
//     li {
//       background-color: white;
//       // border: 1px solid #2684FF;
//       color: rgba(0, 0, 0, 0.6);
//       border: 1px solid #E6E9EB;
//       border-radius: 2px;
//     }
//     li:not(.disabled).active {
//       border: 1px solid #2684FF;
//       color: #2684FF;
//       background-color: white;
//     }
//   }
// }
.search-wrap {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-bottom: 16px;

  .btn-group {
    margin-right: 12px;
    display: flex;
    align-items: center;
    background-color: white;
    cursor: pointer;

    .btn {
      padding: 5px 16px;
      border: 1px solid #e6e9eb;

      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        border-right: none;
      }

      &:not(:first-child):not(:last-child) {
        border-radius: 0;
        border-right: none;
      }

      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }

      &:hover {
        color: #409eff;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
      }
    }

    .btn-active {
      color: white;
      border-color: #4080f9;
      background-color: #4080f9;

      &:hover {
        color: white;
        border-color: #4080f9;
        background-color: #4080f9;
      }
    }
  }

  .tip {
    color: rgba(0, 0, 0, 0.6);
    cursor: pointer;
  }

  .popover {
    // border: 1px solid #2684ff;
    position: absolute;
    top: 1px;
    right: 20px;

    ::v-deep.el-popover {
      z-index: 100;
    }
  }
}

.list {
  z-index: -10;

  .item {
    border: 1px solid #fff;
    float: left;
    width: 85px;
    margin: 5px 3px;
    text-align: center;
    font-size: 13px;
    background: #eeeeee;
    padding: 2px 0;
    cursor: pointer;
  }

  .active {
    background: #d7eaff;
    color: #1a70c9;
    border-color: #409eff;
  }
}

.card-wrap {
  display: grid;
  grid-template-columns: repeat(5, minmax(227px, auto));
  grid-gap: 16px;
  margin-bottom: 16px;

  .card-item {
    background-color: white;
    height: 80px;
    padding: 16px 24px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    .item-icon {
      width: 40px;
      height: 40px;
      margin-right: 12px;
    }

    .item-data {
      width: 100%;
      .data-title {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: rgba(0, 0, 0, 0.6);
        margin-bottom: 4px;
      }

      .data-num {
        font-weight: 500;
        font-size: 20px;
        line-height: 22px;
        color: rgba(0, 0, 0, 0.9);
        display: flex;
        justify-content: space-between;
        width: 100%;
        .card-icon {
          flex-shrink: 0;
        }
        .card-content {
          flex-shrink: 0;
        }
      }
    }
  }
  .isClick {
    cursor: pointer;
  }
}

.zhe-xian-wrap {
  background-color: white;
  padding: 24px;

  .zhe-xian-title {
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .title-name-wrap {
      font-size: 14px;
      margin-right: 80px;
      cursor: pointer;

      .title-name {
        color: rgba(0, 0, 0, 0.9);
        font-weight: bold;
        margin-right: 16px;
      }

      .no-click {
        cursor: default;
      }

      .title-more {
        color: #2684ff;
      }
    }
  }

  #zheXiangTu {
    // width: 100%;
    // max-height: 337px;
    // height: 337px;
  }

  .flag-color {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;

    .line-type {
      display: flex;
      align-items: center;
      font-size: 14px;

      .type-item {
        display: flex;
        align-items: center;
        margin-right: 16px;

        .dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 8px;
        }

        .xin-zeng-dot {
          background-color: #2684ff;
        }

        .xin-bang-dot {
          background-color: #00a870;
        }

        .type-name {
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

.bottom-wrap {
  margin-top: 16px;
  display: flex;
  align-items: center;

  .chat-survey-wrap {
    width: 592px;
    flex: 1;
    background-color: white;
    padding: 20px 24px 30px 24px;
    margin-right: 16px;
    height: 485px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    .head-wrap {
      margin-bottom: 16px;

      .chat-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        margin-bottom: 22px;

        .title-left {
          cursor: pointer;
          display: flex;
          align-items: center;

          .chat-overview {
            margin-right: 36px;
          }

          .tip {
            color: rgba(0, 0, 0, 0.6);
            cursor: pointer;
            font-size: 12px;
          }

          .title-name {
            color: rgba(0, 0, 0, 0.9);
            font-weight: bold;
            margin-right: 16px;
          }

          .title-more {
            color: #2684ff;
          }
        }

        .title-right {
          display: flex;
          align-items: center;
          cursor: pointer;

          .title-btn {
            padding: 2px 12px;
            border: 1px solid #e6e9eb;
            font-size: 12px;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.9);

            &:last-child {
              border-left: none;
              border-radius: 0px 2px 2px 0px;
            }

            &:first-child {
              border-radius: 2px 0px 0px 2px;
            }
          }

          .btn-activ {
            color: #2684ff;
            background: rgba(64, 128, 249, 0.2);
            border-left: 1px solid !important;
            border-color: #2684ff;
          }
        }
      }

      .chat-body {
        display: flex;
        align-items: center;

        .body-li {
          display: flex;
          flex-direction: column;
          margin-right: 32px;
          background: #f1f3f5;
          border-radius: 2px;
          padding: 5px 12px;

          .li-title {
            color: rgba(0, 0, 0, 0.6);
            margin-bottom: 4px;
            font-size: 14px;

            .icon-style {
              margin-left: 5px;
            }
          }

          .li-count-wrap {
            display: flex;
            align-items: center;

            .li-count {
              color: rgba(0, 0, 0, 0.9);
              font-size: 20px;
              font-weight: bold;
            }

            .li-unit {
              font-size: 12px;
              color: rgba(0, 0, 0, 0.6);
              margin-left: 5px;
            }
          }
        }
      }
    }

    #chat-survey {
      flex: 1;
    }
  }

  .staff-rank-wrap {
    width: 592px;
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    height: 485px;
    background-color: white;
    padding: 20px 24px 24px 24px;

    .head-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
      margin-bottom: 16px;

      .tip {
        font-size: 12px;
        color: #7f7f7f;
      }

      .title-name {
        color: rgba(0, 0, 0, 0.9);
        font-weight: bold;
        margin-right: 16px;
      }

      .title-more {
        color: #2684ff;
      }
    }

    .table-wrap {
      flex: 1;
      display: flex;
      flex-direction: column;

      .table-data {
        margin-bottom: 18px;

        /deep/.el-table {
          display: flex;
          flex-direction: column;

          .el-table__body-wrapper {
            flex: 1 !important;
          }
        }

        /deep/.el-table__row .cell {
          padding: 10px 12px;
        }

        /deep/.el-table--medium th {
          padding: 10px 0;
        }

        /deep/ .el-table--medium td {
          padding: 0;
        }
      }

      .staff-pagination {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}

// 表格排序图标
/deep/ .el-table {
  .caret-wrapper {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    height: 22px;
    width: 24px;
    vertical-align: middle;
    cursor: pointer;
    overflow: initial;
    position: relative;

    .sort-caret {
      width: 0;
      height: 0;
      border: 3px solid transparent;
      position: absolute;
      left: 3px;
    }

    .ascending {
      border-bottom-color: #c0c4cc;
      top: 2px;
    }

    .descending {
      border-top-color: #c0c4cc;
      bottom: 5px;
    }
  }

  .descending .sort-caret.descending {
    border-top-color: #409eff;
  }

  .ascending .sort-caret.ascending {
    border-bottom-color: #409eff;
  }
}
</style>
